import { QUICK_VIEW_PRODUCT_OPTIONS_FEATURES } from 'shared/experiments/QuickViewProductOptions/constatants'
import { isExperimentActive } from 'shared/ab-testing'

export function getQuickViewProductOptionsFeatureFlags(rawExperimenationData?: string): string[] {
  const result = []

  const quickViewFeatureFlag = QUICK_VIEW_PRODUCT_OPTIONS_FEATURES.find((ex) => isExperimentActive(ex, rawExperimenationData))

  if (quickViewFeatureFlag) {
    result.push(quickViewFeatureFlag)
  }

  return result
}

export function getContentQueryConfigExperimentFlags(rawExperimenationData?: string): string[] {
  return getQuickViewProductOptionsFeatureFlags(rawExperimenationData)
}
